(function ($) {
  'use strict';

  window.ys.TourDeFrance2023 = new TDF2023();
  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('page-template-skoda-tour-de-france-2023')) {
    window.ys.TDF2023Contest = new TDF2023.Contest();
  }

  $(document).ready(function () {
    $('.promo-articles-carousel').flickity({
      wrapAround: true,
      arrowShape: {
        x0: 25,
        x1: 60,
        y1: 50,
        x2: 70,
        y2: 40,
        x3: 40,
      },
    });
  });
}).bind(window)(jQuery);
